<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.tarrifplans.title") }}</h3>
    <v-alert
      v-if="paymentMessage.show"
      :type="paymentMessage.type"
      :icon="paymentMessage.icon"
    >
      {{ paymentMessage.message }}
    </v-alert>
    <v-card elevation="1" class="pa-3 d-inline-block" :loading="shopSavingInProgress" v-if="activeTarrifplanId!==null && isHavingTarrifplan && activeTarrifplan">
      <v-row>
        <v-col >

            <span class="text-caption">{{ $t("viewSettings.tarrifplans.your_current_tarrifplan") }}</span>
            <h3 v-if="lang==='ru'">
              {{activeTarrifplan.name}}.
            </h3>
            <h3 v-else>
              {{activeTarrifplan[`name_`+lang]}}
            </h3>
            <span class="">
              {{ $t("viewSettings.tarrifplans.paid_until") }} {{
                authenticatedUser &&
                authenticatedUser.shop &&
                authenticatedUser.shop.paid_until | moment("DD.MM.YYYY")
              }}
            </span>

        </v-col>
        <v-col v-if="lang==='ru'">
  <!--        Подключить автоматический платеж-->

          <v-checkbox :label="$t(`viewSettings.tarrifplans.enable_automatic_payments`)"
                      :disabled="shopSavingInProgress || (!isOwnerOfActiveShop && authenticatedUser.id!=250)"
                      v-model="authenticatedUser.shop.is_enabled_automatic_payments"
                      hide-details
                      @change="toggleIsEnabledAutomaticPayments"
          ></v-checkbox>
          <a target="_blank" href="https://levam.net/offer_reccurent_payments.pdf">Оферта</a>
        </v-col>
      </v-row>
    </v-card>
    <v-row
      v-if="
        parseInt(authenticatedUser.shop.demo_is_used) === 0 &&
        !isHavingTarrifplan
      "
    >
      <v-col sm="12" md="6" lg="4" class="py-0 mx-0">
        <v-card elevation="1">
          <v-toolbar class="mt-2" elevation="0">
            <v-toolbar-title>
              {{ $t("viewSettings.tarrifplans.demo_title") }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="py-0">
            <span class="caption">
              {{ $t("viewSettings.tarrifplans.demo_definition") }}
            </span>
          </v-card-text>
          <v-card-actions class="mt-0 mb-0">
            <v-btn
              class="ml-2"
              elevation="0"
              color="success"
              :disabled="!fetched"
              :loading="!fetched"
              @click="activateDemoTarrif"
            >
              {{ $t("viewSettings.tarrifplans.activate") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="overflow-auto tarrifplans">
      <v-col class="px-0 mx-0">
        <div class="d-block" v-html="'&nbsp;'"></div>
        <div
          v-for="(ability, i) in abilities.list.filter((item)=>(item.only_ru && lang==='en')?false:true)"
          :class="{
            'tab-row-tarrif': i % 2 === 0,
            'theme--dark': $vuetify.theme.dark,
          }"
          class="tarrif-ability-row"
        >
          <span class="text-no-wrap px-2">{{ ability.name }}</span>
        </div>
      </v-col>
      <v-col v-for="item in tarrifplans" class="px-0 mx-0">
        <span class="text-no-wrap text-center d-block"
          ><strong>
                <span v-if="lang==='ru'">
                  {{ item.name }}
                </span>
                <span v-else>
                  {{ item.name_en }}
                </span>
          </strong></span
        >
        <div
          v-for="(ability, i) in abilities.list.filter((item)=>(item.only_ru && lang==='en')?false:true)"
          :class="{
            'tab-row-tarrif': i % 2 === 0,
            'theme--dark': $vuetify.theme.dark,
          }"
          class="py-0 my-0"
        >
          <span
            class="text-no-wrap text-center d-block tarrif-ability-row"
            v-html="ability.check(item.ability, abilities)"
          ></span>
        </div>
        <div class="text-center pt-2">
          <div class="text-no-wrap">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <template v-if="parseInt(item.id) === activeTarrifplanId">
                    <v-icon
                      class="pr-2"
                      color="success"
                      text-color="success"
                      right
                      small
                      >fa-check-circle</v-icon
                    >
                  </template>
                </span>
              </template>
              {{ $t("viewSettings.tarrifplans.is_active_tarrifplan") }}
            </v-tooltip>
            <strong>
              <span v-if="lang==='ru'">
              {{ item.price }} ₽
              </span>
              <span v-else>
              {{ item.price_en }} €
              </span>
            </strong>
            {{ $t("viewSettings.tarrifplans.per_month") }}
          </div>
          <div class="pt-1">
            {{ item.definition }}
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                elevation="0"
                color="success"
                :disabled="item.nowSave"
                @click="chooseTarrifplan(item, 'card')"
              >
                <v-icon>mdi-credit-card</v-icon>
                <span v-if="parseInt(item.id) === activeTarrifplanId">
                  {{ $t("viewSettings.tarrifplans.prolong") }}
                </span>
                <span v-else>{{
                  $t("viewSettings.tarrifplans.choose_tarrifplan")
                }}</span>
              </v-btn>
            </template>
            {{ $t("common.pay_with_card") }}
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                class="ml-2"
                elevation="0"
                outlined
                color=""
                :disabled="item.nowSave"
                @click="chooseTarrifplan(item, 'bill')"
              >
                <v-icon>mdi-file-document</v-icon>
              </v-btn>
            </template>
            {{ $t("viewOrdersForm.bill") }}
          </v-tooltip>

          <div>
            <span
              v-if="parseInt(item.id) === activeTarrifplanId"
              class="caption"
            >
              {{ $t("viewSettings.tarrifplans.your_current_tarrifplan") }}
              <br />
              {{ $t("viewSettings.tarrifplans.paid_until") }}:
              <strong
                class="caption success px-2 d-inline-block text--white"
                :class="{ danger: !isHavingTarrifplan }"
                >{{
                  authenticatedUser &&
                  authenticatedUser.shop &&
                  authenticatedUser.shop.paid_until | moment("DD.MM.YYYY")
                }}</strong
              >
            </span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="px-0 mx-0">
        <v-card elevation="0" class="mt-3" v-if="prepayedTarrifplans.length">
          <h4 class="mt-3 ml-3 pt-3">
            {{
              $t("viewSettings.tarrifplans.pre_payed_non_activated_packets")
            }}:
          </h4>
          <template>
            <v-list class="ml-3 my-0 py-0" v-for="item in prepayedTarrifplans">
              <v-list pa-0>
                <span v-if="lang==='ru'">
                  {{ item.tarrifplan.name }}
                </span>
                <span v-else>
                  {{ item.tarrifplan.name_en }}
                </span>
                {{ item.created_at | moment("DD.MM.YYYY HH:mm") }}
              </v-list>
            </v-list>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import router from "../../router";
import RightsMixin from "@/mixins/rights";

export default {
  mixins: [RightsMixin],
  data: () => ({
    paymentMessage: {
      message: "",
      type: "",
      icon: null,
    },
  }),
  created() {
    this.onLoad();
  },
  validations() {},
  computed: {
    ...mapFields("shops", { shopSavingInProgress: "savingInProgress" }),
    ...mapFields("tarrifplans", [
      "fetched",
      "tarrifplans",
      "prepayedTarrifplans",
    ]),
    ...mapFields("auth", ["authenticatedUser"]),
    ...mapFields("site", ["lang"]),
    abilities(){
      return {
      enabled:
          '<img class="ability-img" src="https://sto.levam.net/img/tariffs-table_true.svg"/>',
      disabled:
          '<img  class="ability-img" src="https://sto.levam.net/img/tariffs-table_false.svg"/>',
      list: [
        {
          name: this.$t('viewSettings.tarrifplans_abilities.posts'),//"Посты",
          check: (item, context) => {
            if (item.max_posts_count === 0) return context.disabled;
            return item.max_posts_count > 1000
                ? this.$t('viewSettings.tarrifplans.unlimited')
                : item.max_posts_count;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.creating_orders'),//"Создание заказ-нарядов",
          check: (item, context) => {
            return item.can_use_search > 0 ? context.enabled : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.calendar'),//"Календарь",
          check: (item, context) => {
            return item.can_use_calendar > 0
                ? context.enabled
                : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.works'),//"Работы",
          check: (item, context) => {
            return item.can_use_calendar > 0
                ? context.enabled
                : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.repair_times'),//"Нормы времени ремонта",
          check: (item, context) => {
            return item.can_use_simple_repairtimes ||
            item.can_use_full_repairtimes > 0
                ? context.enabled
                : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.sms_informing_clients'),//"SMS информирование клиентов",
          check: (item, context) => {
            return item.can_send_sms_to_customers > 0
                ? context.enabled
                : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.storage'),//"Склад",
          check: (item, context) => {
            return item.can_use_storage > 0
                ? context.enabled
                : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.suppliers'),//"Поставщики",
          check: (item, context) => {
            if (item.max_suppliers_count === 0) return context.disabled;
            return item.max_suppliers_count > 1000
                ? this.$t('viewSettings.tarrifplans.unlimited')
                : item.max_suppliers_count;
          },
          only_ru: true
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.catalogs'),//"Каталоги",
          check: (item, context) => {
            return item.can_use_catalogs > 0
                ? context.enabled
                : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.aftermarket_service'),//"Сервис управления кроссами",
          check: (item, context) => {
            return item.can_use_am_crosses > 0
                ? context.enabled
                : context.disabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.analytics'),//"Аналитика",
          check: (item, context) => {
            return context.enabled;
          }
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.telephony'),//"Телефония",
          check: (item, context) => {
            return context.enabled;
          },
          only_ru: true
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.online_booking_order_widget'),//"Виджет онлайн записи/заказов",
          check: (item, context) => context.enabled,
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.employees_online'),//"Сотрудников онлайн",
          check: (item, context) => {
            return item.max_users_online_count > 1000
                ? this.$t('viewSettings.tarrifplans.unlimited')
                : item.max_users_online_count;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.number_of_franchisees'),//"Число франчайзи",
          check: (item, context) => {
            if (item.max_franchisee_count === 0) return context.disabled;
            return item.max_franchisee_count;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.automatic_order_and_cart_check'),//"Автоматическая проверка заказа и корзины",
          check: (item, context) => {
            return context.enabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.maintenance_parts'),//"Запчасти для ТО",
          check: (item, context) => {
            return context.enabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.automatic_selection_of_spare_parts_for_repairtime'),//"Автоматический подбор запчастей по работе",
          check: (item, context) => {
            return context.enabled;
          },
        },
        {
          name: this.$t('viewSettings.tarrifplans_abilities.applicability_of_parts'),//"Применимость деталей",
          check: (item, context) => {
            return context.enabled;
          },
        },
      ],
    }
    },
    activeTarrifplan() {
      return this.tarrifplans.find(item=>parseInt(item.id)===parseInt(this.activeTarrifplanId))
    },
    activeTarrifplanId() {
      return (
        parseInt(
          this.authenticatedUser.shop &&
            this.authenticatedUser.shop.tarrifplan_id
        ) || null
      );
    },
    activeTarrifplanPrice() {
      let activeTarrifplan = this.tarrifplans.find((item) => {
        return item.id === this.authenticatedUser.shop.tarrifplan_id;
      });
      if (activeTarrifplan) return activeTarrifplan.price || null;
    },
  },
  methods: {
    async toggleIsEnabledAutomaticPayments() {
      return await this.$store.dispatch("shops/toggleIsEnabledAutomaticPayments", {shop_id: this.authenticatedUser.shop.id}).then((result) => {
        //console.log(result)
        if(result && result.status=== "success") {
            this.is_enabled_automatic_payments = result.is_enabled_automatic_payments
          }
      });
    },
    activateDemoTarrif() {
      this.$store.dispatch("tarrifplans/activateDemoTarrif").then((result) => {
        if (result) this.$router.go();
      });
    },
    onLoad() {
      this.$store.dispatch("tarrifplans/get");
      this.$store.dispatch("tarrifplans/getPrepayedTarrifplans");
      if (this.$route.params.status) {
        switch (this.$route.params.status) {
          case "fail":
            this.paymentMessage.icon = "fa-exclamation-triangle";
            this.paymentMessage.type = "warning";
            this.paymentMessage.show = true;
            this.paymentMessage.message = this.$t(
              "viewSettings.tarrifplans.payment_failed"
            );
            break;
          case "success":
            this.paymentMessage.icon = "fa-check-circle";
            this.paymentMessage.type = "success";
            this.paymentMessage.show = true;
            this.paymentMessage.message = this.$t(
              "viewSettings.tarrifplans.payment_success"
            );
            break;
        }
      }
    },
    chooseTarrifplan(item, type) {
      let paymentProvider;
      if(this.lang === 'ru') {
          paymentProvider = type === 'card' ? 'tinkoff' : 'bill';
      } else {
          paymentProvider =  type === 'card' ? 'Payproglobal' : 'bill';
      }
      this.$store.dispatch("tarrifplans/pay", { ...item, payment_type:paymentProvider });
    },
  },
  watch: {
    "$route.params"() {
      //paymentMessage.icon
      this.paymentMessage.icon = "fa-check-circle";
      this.paymentMessage.type = "success";
      this.paymentMessage.show = true;
      this.paymentMessage.message = true;
    },
  },
};
</script>

<style lang="scss">
.tarrifplans {
  overflow-x: auto;
  width: 100%;
  flex-wrap: nowrap;
}
.ability-img {
  margin-top: 5px;
}
.tab-row-tarrif:nth-child(2n) {
  background-color: map-get($blue, 'lighten-5');
}
.tarrif-ability-row:nth-child(2n) {
  background-color: map-get($blue, 'lighten-5');
}

.tarrif-ability-row {
  height: 29px;
  line-height: 29px;
}
.tab-row-tarrif {
  background-color: white;
}
.tab-row-tarrif.theme--dark {
  background-color: #121212;
}
</style>
